import { fmtTicketDate, getPilgrims, perTicketAmount, reportingFor, sevaCode } from "../utils/pdfGenerator";

const instructions = [
  "At the time of entry, all the pilgrims should carry individual ticket and shall produce the same original photo ID used during booking.",
  "Pilgrims shall wear traditional dress only. Male: Dhoti/Shirt/Kurtha, Pyjama. Female: Saree/Half saree/Chudidar with dupatta.",
  "All the pilgrims shall report as per their time slot only and should not carry any luggage/electronic gadgets while reporting.",
  "Pilgrims having darshan slot will be allowed through Alipiri/Srivari Mettu footpaths only after 9 AM on the previous day of darshan.",
  "Pilgrims shall collect the Prasadam within 24 Hrs from the reporting time for Darshan.",
  "Cancellation is allowed only through the booking portal before the visit date.",
  "TTD reserves the right of cancellation of Darshan under special circumstances.",
];

export const TicketPreview = ({ booking, qr }) => {
  const pilgrims = getPilgrims(booking);
  const { time: reporting, place: reportAt } = reportingFor(booking.service, booking.slot);
  const price = perTicketAmount(booking, pilgrims.length);
  const code = sevaCode(booking.service);
  return (
    <div className="ticket-preview-list" data-testid="ticket-preview-list">
      {pilgrims.map((pilgrim, index) => (
        <div className="tkt" key={index} data-testid={`ticket-preview-${index}`}>
          <div className="tkt-main">
            <div className="tkt-head">
              <img className="tkt-logo" src="/ttd-emblem.png" alt="Tirumala Tirupati Devasthanams emblem" />
              <div className="tkt-titles">
                <b>Tirumala Tirupati Devasthanams</b>
                <span>{booking.service} (Rs.{price})</span>
              </div>
            </div>
            <div className="tkt-barcode" />
            <span className="tkt-ref">{booking.booking_id}{index + 1}</span>
            <div className="tkt-report">
              <div><span>Reporting Time:</span><b>{reporting} / {fmtTicketDate(booking.date)}</b></div>
              <div><span>Report At:</span><b>{reportAt}</b></div>
            </div>
            <div className="tkt-fields">
              <div className="tkt-frow"><span>No. of free laddus: <b>1</b></span><span className="tkt-amount">Amount: <b className="red">₹.{price}</b></span></div>
              <div className="tkt-frow"><span>Group Booking Id : <b className="red">{booking.booking_id}</b></span></div>
              <div className="tkt-frow"><span>Booking Date : <b className="red">{fmtTicketDate(booking.date)}</b></span></div>
              <div className="tkt-frow"><span>Pilgrim Name : <b>{pilgrim.name}</b></span></div>
              <div className="tkt-frow"><span>Gender/Age : <b>{pilgrim.gender}/{pilgrim.age}</b></span></div>
              <div className="tkt-frow"><span>Photo ID Number : <b>{String(pilgrim.id_type).toUpperCase()}/{pilgrim.id_number}</b></span></div>
              {qr && <img src={qr} alt={`QR code for ${booking.booking_id}`} className="tkt-qr-inline" data-testid={`ticket-qr-${index}`} />}
            </div>
            <p className="tkt-note">NOTE : This is an electronically generated document and does not require any signature.</p>
            <p className="tkt-exec">Executive Officer, Tirumala Tirupati Devasthanams</p>
          </div>
          <div className="tkt-stub">
            <div className="tkt-stub-top"><span className="tkt-bigtime">{reporting}</span><span className="tkt-sed">{code}</span></div>
            <p className="tkt-info-title">Important Information To The Pilgrims</p>
            <ol>{instructions.map((line, i) => <li key={i}>{line}</li>)}</ol>
          </div>
        </div>
      ))}
    </div>
  );
};
